export enum DemandPartnerBidderCode {
  TritonDigital = 'tritondigital',
  Sonobi = 'sonobi',
  Unruly = 'unruly',
  SpringServe = 'springserve',
  TrustedMarketplace = 'trustedmarketplace',
  Adswizz = 'adswizz',
  EdgeMarkets = 'edgemarkets',
  Pubmatic = 'pubmatic',
  Beachfront = 'beachfront',
  Appnexus = 'appnexus',
  Ix = 'ix',
  Amx = 'amx',
  Rhythmone = 'rhythmone',
  Triplelift = 'triplelift',
  Onetag = 'onetag',
  Verizon = 'verizon',
  Openx = 'openx',
  Yieldmo = 'yieldmo',
  Krushmedia = 'krushmedia',
  Acuityads = 'acuityads',
  Bidswitch = 'bidswitch',
  Aniview = 'aniview',
  Leanback = 'leanback',
  Mediafuse = 'mediafuse',
  Nobid = 'nobid',
  Undertone = 'undertone',
  Freewheel = 'freewheel',
  Sabio = 'sabio',
  Mediagrid = 'mediagrid',
  Epsilon = 'epsilon',
  Smaato = 'smaato',
  Smartadserver = 'smartadserver',
  Sharethrough = 'sharethrough',
  Viant = 'viant',
  Improvedigital = 'improvedigital',
  Wideorbit = 'wideorbit',
  Rubicon = 'rubicon',
  Colossus = 'colossus',
  Sovrn = 'sovrn',
  Adman = 'adman',
  Admixer = 'admixer',
  Adtelligent = 'adtelligent',
  Bmtm = 'bmtm',
  Districtm = 'districtm',
  Emx = 'emx',
  Google = 'google',
  Gumgum = 'gumgum',
  Pocketmedia = 'pocketmedia',
  Decenterads = 'decenterads',
  NineMediaOnline = '9mediaonline',
  Adnuro = 'adnuro',
  Amitydigital = 'amitydigital',
  Ottera = 'ottera',
  Pixfuture = 'pixfuture',
  Streamkey = 'streamkey',
  Tetratv = 'tetratv',
  Vitormedia = 'vitormedia',
  Roku = 'roku',
  Vlogbox = 'vlogbox',
  Tikilive = 'tikilive',
  Spotx = 'spotx',
  Glewedtv = 'glewedtv',
  Inmobi = 'inmobi',
  Resetdigital = 'resetdigital',
  Jamloop = 'jamloop',
  Kubient = 'kubient',
  Madhive = 'madhive',
  Mobfox = 'mobfox',
  Origin = 'origin',
  Smartclip = 'smartclip',
  Smartyads = 'smartyads',
  Stroer = 'stroer',
  Synacor = 'synacor',
  Tappx = 'tappx',
  Teads = 'teads',
  Telaria = 'telaria',
  Iponweb = 'iponweb',
  Theviewpoint = 'theviewpoint',
  Trustx = 'trustx',
  Vrtcal = 'vrtcal',
  Zedo = 'zedo',
  Column6 = 'column6',
  Other = 'other',
  Publica = 'publica',
  Zeta = 'zeta',
  Rtbiq = 'rtbiq',
  Jwplayer = 'jwplayer',
  Lgads = 'lgads',
  Kargo = 'kargo',
  Adf = 'adf',
  Xandr = 'xandr',
  Risecodes = 'risecodes',
  Ttd = 'ttd',
  LoopMe = 'LoopME',
  FreewheelHax = 'freewheel_hax',
  FreewheelCastify = 'freewheel_castify',
  FreewheelAdipolo = 'freewheel_adipolo',
  FreewheelPositive = 'freewheel_positive',
  FreewheelSilo = 'freewheel_silo',
  FreewheelCinemoon = 'freewheel_cinemoon',
  FreewheelBidfuse = 'freewheel_bidfuse',
  AdswizzDx = 'adswizz_dx',
  MediagridAdapex = 'mediagrid_adapex',
  OpenxAdnimation = 'openx_adnimation',
  OpenxPowerads = 'openx_powerads',
  AdtelligentAudienceconnect = 'adtelligent_audienceconnect',
  AdtelligentCastify = 'adtelligent_castify',
  AdtelligentBoldcollective = 'adtelligent_boldcollective',
  AdtelligentPhonder = 'adtelligent_phonder',
  Atomik = 'atomik',
  PublicaAdsmovil = 'publica_adsmovil',
  PublicaFilmzie = 'publica_filmzie',
  ColossusBidfuse = 'colossus_bidfuse',
  ColossusBenefitads = 'colossus_benefitads',
  ColossusCinepulse = 'colossus_cinepulse',
  PllCastify = 'pll_castify',
  PllHax = 'pll_hax',
  PllBidfuse = 'pll_bidfuse',
  PllBenefit = 'pll_benefit',
  BidswitchDx = 'bidswitch_dx',
  TripleliftCastify = 'triplelift_castify',
  XandrCinemoon = 'xandr_cinemoon',
  XandrCastify = 'xandr_castify',
  XandrWidesound = 'xandr_widesound',
  XandrJamx = 'xandr_jamx',
  ConsumableBenefitads = 'consumable_benefitads',
  ConsumableJamx = 'consumable_jamx',
  EplanningBenefitads = 'eplanning_benefitads',
  SmartadserverBenefitads = 'smartadserver_benefitads',
  IndicueFilmhub = 'indicue_filmhub',
  IndicueTviq = 'indicue_tviq',
  IndicueSportx = 'indicue_sportx',
  IndicueMultimerica = 'indicue_multimerica',
  IndicueKivi = 'indicue_kivi',
  IndicueMoonball = 'indicue_moonball',
  LoopMePowerads = 'LoopME_powerads',
  LoopMeBenefitads = 'LoopME_benefitads',
  Mirai = 'mirai',
  SpringserveMultimerica = 'springserve_multimerica',
  UnrulyDx = 'unruly_dx',
  PubmaticDx = 'pubmatic_dx',
  ZetaDx = 'zeta_dx',
  PllFilmzie = 'pll_filmzie',
  ColossusPwrads = 'colossus_pwrads',
  Targetspot = 'targetspot',
  ElementalTv = 'elemental_tv',
  Madsense = 'madsense',
  OrkaTv = 'orka_tv',
  MediaNet = 'media_net',
  Snackmedia = 'snackmedia',
  Adtonos = 'adtonos',
  Showheroes = 'showheroes',
  Iqzone = 'iqzone',
  Smilewanted = 'smilewanted',
}

export const demandPartnerBidderCodes = Object.values(DemandPartnerBidderCode);
